import { api } from '../helpers';

const getAll = async () => {
    return await api.get('/admin-dcct/tinh-trang/all').then((response) => {
        return response.data;
    });
};

const filterList = async (page: number | null, size: number | null, sort: string | null) => {
    const params = { page, size, sort };
    return await api.get('/tinh-trangs', { params }).then((response: any) => {
        return response;
    });
};

const deleteById = async (id: any) => {
    return await api.delete(`/tinh-trangs/${id}`).then((response: any) => {
        return response;
    });
};

const create = async (id: any, tenTinhTrang: string) => {
    const payLoad = {
        id, tenTinhTrang
    };
    return await api.post('/tinh-trangs', payLoad).then((response: any) => {
        return response;
    });
};

const getById = async (id: any) => {
    return await api.get(`/tinh-trangs/${id}`).then((response: any) => {
        return response;
    });
};

const update = async (id: any, tenTinhTrang: string) => {
    const payLoad = {
        id, tenTinhTrang
    };
    return await api.patch(`/tinh-trangs/${id}`, payLoad).then((response: any) => {
        return response;
    });
};

export const tinhTrangService = {
    getAll,
    filterList,
    deleteById,
    create,
    getById,
    update
};